import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Image,
  Row,
  Card,
  Form,
  Input,
  Space,
  Typography,
  Spin,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { images, SIZES, COLORS } from "../../constants";

import { Link, useNavigate, useLocation } from "react-router-dom";
import Notification from "../shared/Notification";
import BackgroundContainer from "../../v2/components/BackgroundContainer/BackgroundContainer";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const { Paragraph, Title } = Typography;

function Login() {
  const [forms] = Form.useForm();
  const [isUpdated, setisUpdated] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const query = useQuery();

  useEffect(() => {
    if (query.get("uid") && query.get("token")) {
      let _userId = query.get("uid");
      let _token = query.get("token");

      setIsLoading(true);
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL}/password-reset/checking/${_userId}/${_token}`
        )
        .then(({ data }) => {
          if (!data.isValidLink) {
            Notification(
              "Invalid Link or Expired!",
              "Please request another link to reset password",
              "error"
            );
            navigate("/");
          }
        })
        .catch((error) => {
          Notification("Error occured!", error + "!", "error");
          navigate("/");
        })
        .then(() => setIsLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const antIcon = <LoadingOutlined style={{ fontSize: 50 }} spin />;

  const onPasswordReset = (data) => {
    let userId = query.get("uid");
    let token = query.get("token");
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/password-reset/${userId}/${token}`,
      data: data,
    })
      .then(({ data }) => {
        setisUpdated(data.isUpdated);
        forms.resetFields();
        Notification(
          "Password is updated!",
          "You can now login with your new password",
          "success"
        );
      })
      .catch((error) => {
        Notification("Error occured!", error + "!", "error");
      });
  };

  return (
    <BackgroundContainer>
      <Row
        type="flex"
        justify="center"
        align="middle"
        style={{ minHeight: "100vh" }}
      >
        <Form
          form={forms}
          name="password-reset"
          initialValues={{ remember: true }}
          onFinish={onPasswordReset}
          autoComplete="off"
        >
          <Space direction="horizontal" size={"small"}>
            <Image
              preview={false}
              src={images.gensanLogo}
              className="logo"
              width={100}
              style={{ margin: "10px 5px 10px 5px" }}
            />

            <Image
              src={images.tourismLogo}
              preview={false}
              className="tourismLogo"
              width={250}
            />
          </Space>
          <Row justify="center" align="middle">
            <Card style={{ borderRadius: SIZES.base, width: 320, height: 300 }}>
              {isLoading ? (
                <Row justify="center" align="middle" style={{ height: 240 }}>
                  <Spin indicator={antIcon} />
                </Row>
              ) : (
                <>
                  {isUpdated ? (
                    <Row justify="center" align="middle">
                      <center style={{ marginBottom: SIZES.base * 3 }}>
                        <Title level={4}>
                          Password has been successfully updated!
                        </Title>
                        <Link to={"/"}>
                          <Paragraph style={{ color: COLORS.blue1 }}>
                            Go back to login!
                          </Paragraph>
                        </Link>
                      </center>
                    </Row>
                  ) : (
                    <>
                      <center style={{ marginBottom: SIZES.base * 3 }}>
                        <Title level={4}>Password Reset</Title>
                        <Paragraph>Enter your new password!</Paragraph>
                      </center>

                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Please input your password!",
                          },
                        ]}
                        hasFeedback
                      >
                        <Input.Password placeholder="New Password *" />
                      </Form.Item>

                      <Form.Item
                        name="confirmpassword"
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: "Please confirm your password!",
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "The two passwords that you entered do not match!"
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password placeholder="Confirm Password *" />
                      </Form.Item>

                      <Form.Item>
                        <Button
                          type="primary"
                          htmlType="submit"
                          style={{ width: "100%", marginBottom: SIZES.body2 }}
                        >
                          Confirm
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </>
              )}
            </Card>
          </Row>
        </Form>
      </Row>
    </BackgroundContainer>
  );
}

export default Login;
